export function trackGTMEvent(
	eventName: string,
	params: Record<string, unknown> = {},
): void {
	if (typeof window === 'undefined') return;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event: eventName, ...params });
}
